import styled from 'styled-components';

import FormGroup from '@mui/material/FormGroup';
import deviceBreakpoints from 'utilities/deviceBreakpoints';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const ButtonContainer = styled(FormContainer)`
  justify-content: flex-end;
  padding-right: 5px;
`;

export const DeleteMessage = styled.div`
  margin: 10px 0;
  text-align: center;
`;

export const DetailsHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DetailsTitle = styled.div`
  display: inline-block;
  margin-right: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #abb1b1;
  text-transform: uppercase;
`;

export const DialogContainer = styled.div``;

export const containerPaddingPx = 24;

const containerString = `
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
  overflow: hidden;

  width: 650px;
  box-sizing: border-box;
  position: relative;

  @media ${deviceBreakpoints.tablet} {
    width: 100%;
  }
`;

export const DialogContentContainer = styled.div`
  ${containerString}
`;
export const DialogContentFormContainer = styled.form`
  ${containerString}
`;

export const DialogMainContent = styled.div`
  padding: 12px ${containerPaddingPx}px;
  overflow: auto;
  margin: 0;
`;

export const FlexCell = styled.div`
  flex: 1 1 auto;
`;

export const HorizontalRule = styled.hr`
  margin: 20px 0;
  height: 1px;
  width: 100%;
  border: none;
  background-color: #eaeded;
`;

export const PaddedFormGroup = styled(FormGroup)`
  margin: 5px 0 28px;
`;

export const PaddedTextFieldContainer = styled.div`
  margin-bottom: 10px;
`;

export const TitleSpan = styled.span`
  display: block;
  margin: 0 0 20px 10px;
  text-transform: capitalize;
`;

export const TruncedTextFieldContainer = styled(PaddedTextFieldContainer)`
  width: 49%;
`;

export const TruncContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
